import { controls } from "../../controls";

const rp959 = {
  label: "SEASONAL ADVANCES",
  pageLabel: "SEASONAL ADVANCES",
  starting: true,
  url: "rp959",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
    
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "SEASONAL ADVANCES",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr No",
        accessor: "domain_code",
        width: 80,
        rwidth: 40

      },
      {
        Header: "Month",
        accessor: "month_name",
        width: "*",
        rwidth: "*"
      },
      
      {
        Header: "Kharip",
        accessor: "kharip_name",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Rubbi",
        accessor: "rubbi_name",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Pulses",
        accessor: "pulses_name",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Sugarcane",
        accessor: "sugarcane_name",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "K C C",
        accessor: "kcc_name",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Total",
        accessor: "total_name",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Of which to small farmers",
        accessor: "kharip_name",
        width: "*",
        rwidth: "*"
      },


    ]
  }
};

export default rp959;